import React from 'react';
import { CaretUpFill } from 'react-bootstrap-icons';

/**
 * QuantityErrorMessage Component
 *
 * Displays a callout when batch lot totals do not match the received quantity.
 * Rendered below lot rows inside a mismatched order item panel; the up icon
 * directs attention to the batch quantity fields above.
 *
 * @returns {JSX.Element} White frosted callout with rose accent and up icon.
 */
const QuantityErrorMessage = () => {
  return (
    <div className="order-quantity-error-callout" role="alert">
      <span className="order-quantity-error-callout__icon" aria-hidden="true">
        <CaretUpFill />
      </span>
      <span className="order-quantity-error-callout__text">
        Total batch quantity does not match expected quantity
      </span>
    </div>
  );
};

export default QuantityErrorMessage;